import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom';
import { faArrowLeft, faArrowRight, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


function Order() {
    const [order, setOrder] = useState(null)
    const [loading, setLoading] = useState(false)
    const token = localStorage.getItem('authToken');
    const { id } = useParams();

    const API_URL = process.env.REACT_APP_API_URL;

    useEffect(() => {
        fetchOrder()
    }, [])

    const fetchOrder = async () => {
        try {
            const response = await fetch(`${API_URL}/order/order/${id}`, {
                method: 'GET',
                headers: {
                    "Authorization": `Bearer ${token}`,
                    'Content-Type': 'application/json',  // Specify the content type
                }
            }
            )
            const result = await response.json()
            setOrder(result.data)
            setLoading(false)
        }
        catch (error) {
        }
    }

    let datePart = '';
    let timePart = '';
    if (order && order.created) {
        const dateObject = new Date(order.created);
        const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
        datePart = dateObject.toLocaleDateString('en-GB', options);
        timePart = dateObject.toLocaleTimeString();
    }





    if (!order) {
        return <div>Нема информации за оваа нарачка</div>;
    }


    return (
        <>
            <Link to={-1}>
                <button className='btn btn-third btn-sm'> <FontAwesomeIcon className='text-xl' icon={faArrowLeft} /> Врати се назад</button>
            </Link>
            <div className="max-w-4xl mx-auto bg-white p-8 rounded-lg shadow-lg">
                <h2 className="text-2xl font-bold text-center mb-6">Детали за нарачка {order.orderNumber}</h2>

                <div className="mb-6 flex flex-col md:flex-row">
                    <div className="space-y-2">
                        <h3 className="text-lg font-bold underline flex-none">Информации за корисникот</h3>
                        <p><strong>Име:</strong> {order.customer.firstName} {order.customer.lastName}</p>
                        <p><strong>Емаил:</strong> {order.customer.emailAddress}</p>
                        <p><strong>Адреса:</strong> {order.customer.street} {order.customer.number}</p>
                        <p><strong>Град:</strong> {order.customer.city}</p>
                        <p><strong>Општина:</strong> {order.customer.municipality}</p>
                        <p><strong>Телефон:</strong> {order.customer.phoneNumber}</p>
                    </div>
                    <div className='ml-0 md:ml-auto mt-2 md:mt-0 max-w-[100%] md:max-w-[50%]'>
                        {order.additionalDescription ? (<> <strong><p>Дополнителна забелешка за достава:</p></strong> <p className='border'>{order.additionalDescription}</p> </>)
                            : (<strong><p>Корисникот нема дополнителна забелешка</p></strong>)}
                        <strong><p>Број на шасија (VIN):</p></strong>
                        {order.vinNumber ? (<> <p className='border'>{order.vinNumber}</p> </>)
                            : (<p>Корисникот нема оставено број на шасија</p>)}
                    </div>
                </div>

                <div className="mb-6">
                    <h3 className="text-lg font-bold underline">Информации за нарачката</h3>
                    <div className="space-y-2">
                        <p><strong>Број на нарачка: </strong>{order.orderNumber}</p>
                        <p><strong>Датум и време на нарачка: </strong> {datePart} {timePart}</p>
                    </div>
                </div>

                <div className="mb-6">
                    <h3 className="text-lg font-bold underline">Нарачани производи</h3>
                    <ul className="space-y-4">
                        {order.orderItems.map((product, index) => (
                            <>
                                <li key={index} className="flex justify-between">
                                    <span>
                                        {product.item.title} x <strong>{product.quantity}</strong> <p>({product.selectedCar})</p>
                                        <p>({product.item.discountedPrice > 0 ? (
                                            <>
                                                <span className="line-through text-gray-500 mr-2">{product.item.price}</span>
                                                <span>{product.item.discountedPrice} ден</span>
                                            </>
                                        ) : (
                                            <span>{product.item.price} ден</span>
                                        )})</p>
                                    </span>
                                    <span>
                                        {product.item.discountedPrice > 0
                                            ? product.item.discountedPrice * product.quantity
                                            : product.item.price * product.quantity} денари
                                    </span>
                                </li>
                                <hr />
                            </>

                        ))}
                        {order.coupon && (<><li className="flex justify-between">
                            <span className='font-semibold'>Купон за попуст: {order.coupon.couponNumber}</span>
                            <span>-{order.coupon.ammount}%</span>
                        </li></>)}
                        <hr />
                        <li className="flex justify-end">
                            <span className='font-semibold mr-2'>Меѓузбир: </span>
                            <span>{order.totalPrice - order.deliveryPrice} денари</span>
                        </li>
                        <li className="flex justify-end">
                            <span className='font-semibold mr-2'>Достава:</span>
                            <span>{order.deliveryPrice > 0 ? order.deliveryPrice + ' денари' : 'Доставата е бесплатна'}</span>
                        </li>
                        <li className="flex justify-end">
                            <span className='font-semibold mr-2'>Начин на плаќање:</span>
                            <span>{order.paymentDescription}</span>
                        </li>
                    </ul>
                </div>
                <hr />
                <div className="flex justify-end font-semibold text-lg">
                    <span className='mr-2'>Вкупно за плаќање: </span>
                    <span> {order.totalPrice} денари</span>
                </div>
            </div>
        </>
    )
}

export default Order
